import { render, staticRenderFns } from "./page-top-svg-icons.vue?vue&type=template&id=421adc5b&scoped=true"
import script from "./page-top-svg-icons.vue?vue&type=script&lang=js"
export * from "./page-top-svg-icons.vue?vue&type=script&lang=js"
import style0 from "./page-top-svg-icons.vue?vue&type=style&index=0&id=421adc5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421adc5b",
  null
  
)

export default component.exports